module.exports = __webpack_public_path__ + "static/media/ecommerce.ecd890e8.png";